import type { AutoFormWidgetsProps } from '../autoForm'
import { S3FileWidget } from './s3FileWidget'
import { SingleFileWidget } from './singleFileWidget'

export const FileWidget = (props: AutoFormWidgetsProps) => {
  if (props.options?.multiple) {
    return <S3FileWidget {...props} />
  }

  return <SingleFileWidget {...props} />
}
